import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { PartnerListItem } from '../../api/queries';
import classes from './PartnerTable.module.css';
import { formatNorwegianDate } from '../../utils/dateFormatters';
import { Routes } from '../../enums/Routes';
import { buildRoute } from '../../utils/routeBuilder';

const formatCashbackPercentage = (basisPoints: number | null): string => {
  if (basisPoints === null) return '-';
  return `${(basisPoints / 100).toFixed(0)}%`;
};

interface PartnerTableProps {
  partners: PartnerListItem[];
}

export const PartnerTable = ({ partners }: PartnerTableProps): ReactElement => {
  const navigate = useNavigate();

  const handleRowClick = (partnerId: number) => {
    const detailRoute = buildRoute(Routes.SystemAdminPartnerDetail, { partnerId });
    navigate(detailRoute);
  };

  const handleKeyDown = (event: React.KeyboardEvent, partnerId: number) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleRowClick(partnerId);
    }
  };

  return (
    <div className={classes.tableContainer}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>Partner</th>
            <th>Kontakt-epost</th>
            <th>Telefon</th>
            <th>Cashback</th>
            <th>Opprettet</th>
            <th>Antall kunder</th>
          </tr>
        </thead>
        <tbody>
          {partners.map((partner) => (
            <tr
              key={partner.id}
              onClick={() => handleRowClick(partner.id)}
              onKeyDown={(e) => handleKeyDown(e, partner.id)}
              tabIndex={0}
              className={classes.clickableRow}
              role="button"
              aria-label={`Åpne detaljer for ${partner.name}`}
            >
              <td className={classes.nameCell}>
                <strong>{partner.name}</strong>
              </td>
              <td>{partner.contactEmail}</td>
              <td>{partner.contactPhone || '-'}</td>
              <td>{formatCashbackPercentage(partner.cashbackPercentage)}</td>
              <td>{formatNorwegianDate(partner.createdAt)}</td>
              <td>{partner.customerCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
